<template>
  <div>
    <section class="email-protect ly-wrap">
      <div class="email-protect-ttl">
        <h2 class="ly-cont-m">고정형 영상정보처리기기 운영·관리 방침</h2>
        <div class="line"></div>
      </div>
      <div class="ly-cont-m email-protect-txt">
        <div class="warp">
          <p class="spolicy-intro">
            ㈜다비치안경체인(이하 '회사'라 함)은 고정형 영상정보처리기기
            운영·관리 방침을 통해 회사에서 처리하는 개인영상정보가 어떠한 용도와
            방식으로 이용·관리되고 있는지 알려드립니다.
          </p>
          <div class="sections">
            <!-- Section 1 -->
            <section>
              <h2 class="section-heading">1. 설치 근거 및 목적</h2>
              <p>
                회사는 「개인정보 보호법」 제25조제1항에 따라 다음과 같은
                목적으로 고정형 영상정보처리기기를 설치·운영 합니다.
              </p>
              <ul class="section-list">
                <li>시설안전 및 관리, 화재 예방</li>
                <li>범죄 예방 및 회사 기밀 유출 방지</li>
                <li>차량도난 및 파손방지</li>
              </ul>
            </section>

            <!-- Section 2 -->
            <section>
              <h2 class="section-heading">
                2. 설치 대수, 설치 위치 및 촬영 범위
              </h2>
              <div class="table-container">
                <table class="policy-table">
                  <thead class="bg-gray-100">
                    <tr>
                      <th class="px-4 py-2 border">건물</th>
                      <th class="px-4 py-2 border">설치 대수</th>
                      <th class="px-4 py-2 border">설치 위치 및 촬영 범위</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="px-4 py-2 border">본사(서울 종로)</td>
                      <td class="px-4 py-2 border">13대</td>
                      <td class="px-4 py-2 border">
                        8층~11층 사무실 출입구 및 내부, 서버실 입구
                      </td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">Essential Center(대전)</td>
                      <td class="px-4 py-2 border">15대</td>
                      <td class="px-4 py-2 border">
                        지하층, 1층~4층 강의실 출입구 및 복도, 옥외 주차장
                      </td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">Innovation Center(대전)</td>
                      <td class="px-4 py-2 border">19대</td>
                      <td class="px-4 py-2 border">
                        1층~3층 강의실 출입구 및 복도, 옥외 주차장
                      </td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">Vision Center(대전)</td>
                      <td class="px-4 py-2 border">19대</td>
                      <td class="px-4 py-2 border">
                        4층~5층 강의실 출입구 및 복도
                      </td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">물류센터(경북 경산)</td>
                      <td class="px-4 py-2 border">43대</td>
                      <td class="px-4 py-2 border">
                        사무실·출고동, 진열동·창고동 출입구 및 내부·복도
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <!-- Section 3 -->
            <section>
              <h2 class="section-heading">3. 관리책임자 및 접근권한자</h2>
              <p class="mb-2">
                귀하의 개인영상정보를 보호하고 개인영상정보와 관련한 불만을
                처리하기 위하여 아래와 같이 관리책임자 및 접근권한자를
                지정합니다.
              </p>
              <p class="text-sm mb-4">
                ※ 관련법령: 「표준 개인정보 보호지침」 제37조(관리책임자의 지정)
              </p>
              <div class="table-container">
                <table class="policy-table">
                  <thead class="bg-gray-100">
                    <tr>
                      <th class="px-4 py-2 border">건물</th>
                      <th class="px-4 py-2 border">관리책임자(직위·소속)</th>
                      <th class="px-4 py-2 border">연락처</th>
                      <th class="px-4 py-2 border">접근권한자(직위·소속)</th>
                      <th class="px-4 py-2 border">연락처</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="px-4 py-2 border">본사</td>
                      <td class="px-4 py-2 border">이해리 팀장(인사팀)</td>
                      <td class="px-4 py-2 border">070-7405-1003</td>
                      <td class="px-4 py-2 border">김남혁 매니저(인사팀)</td>
                      <td class="px-4 py-2 border">070-4348-7448</td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">연구원</td>
                      <td class="px-4 py-2 border">
                        안성수 팀장(연구개발확산팀)
                      </td>
                      <td class="px-4 py-2 border">070-7428-6638</td>
                      <td class="px-4 py-2 border">김남혁 매니저(인사팀)</td>
                      <td class="px-4 py-2 border">070-4348-7448</td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">물류센터</td>
                      <td class="px-4 py-2 border">강동규 팀장(물류센터)</td>
                      <td class="px-4 py-2 border">070-7433-0131</td>
                      <td class="px-4 py-2 border">김남혁 매니저(인사팀)</td>
                      <td class="px-4 py-2 border">070-4348-7448</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <!-- Section 4 -->
            <section>
              <h2 class="section-heading">
                4. 개인영상정보의 촬영시간, 보관기간, 보관장소 및 처리방법
              </h2>
              <p class="mb-2">
                - 처리방법: 개인영상정보의 목적 외 이용, 제3자 제공, 파기, 열람
                등 요구에 관한 사항을 기록·관리하고, 보관기간 만료 시 복원이
                불가능한 방법으로 영구 삭제(출력물의 경우 파쇄 또는 소각)합니다.
              </p>
              <div class="table-container mb-4">
                <table class="policy-table">
                  <thead class="bg-gray-100">
                    <tr>
                      <th class="px-4 py-2 border">건물</th>
                      <th class="px-4 py-2 border">촬영시간</th>
                      <th class="px-4 py-2 border">보관기간</th>
                      <th class="px-4 py-2 border">보관장소</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="px-4 py-2 border">본사</td>
                      <td class="px-4 py-2 border">24시간</td>
                      <td class="px-4 py-2 border">촬영일로부터 2주</td>
                      <td class="px-4 py-2 border">서버실</td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">연구원</td>
                      <td class="px-4 py-2 border">24시간</td>
                      <td class="px-4 py-2 border">촬영일로부터 2주</td>
                      <td class="px-4 py-2 border">서버실</td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">물류센터</td>
                      <td class="px-4 py-2 border">24시간</td>
                      <td class="px-4 py-2 border">촬영일로부터 5주</td>
                      <td class="px-4 py-2 border">서버실</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <!-- Section 5 -->
            <section>
              <h2 class="section-heading">5. 설치 및 관리 위탁에 관한 사항</h2>
              <p class="mb-2">
                회사는 아래와 같이 고정형 영상정보처리기기 설치 및 관리 등을
                위탁하고 있으며, 관계 법령에 따라 위탁계약 시 개인정보가
                안전하게 관리될 수 있도록 필요한 사항을 규정하고 있습니다.
              </p>
              <div class="table-container">
                <table class="policy-table">
                  <thead class="bg-gray-100">
                    <tr>
                      <th class="px-4 py-2 border">건물</th>
                      <th class="px-4 py-2 border">수탁업체</th>
                      <th class="px-4 py-2 border">담당자 및 연락처</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="px-4 py-2 border">본사</td>
                      <td class="px-4 py-2 border">에스케이쉴더스㈜</td>
                      <td class="px-4 py-2 border">
                        김형진 수석 010-3215-2558
                      </td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">연구원</td>
                      <td class="px-4 py-2 border">에스케이쉴더스㈜</td>
                      <td class="px-4 py-2 border">
                        김형진 수석 010-3215-2558
                      </td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">물류센터</td>
                      <td class="px-4 py-2 border">에스케이쉴더스㈜</td>
                      <td class="px-4 py-2 border">
                        김형진 수석 010-3215-2558
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <!-- Section 6 -->
            <section>
              <h2 class="section-heading">
                6. 개인영상정보의 확인 방법 및 장소
              </h2>
              <ul class="list-disc list-inside space-y-1">
                <li>
                  확인 방법: 해당 개인영상정보 관리책임자에게 미리 연락하고
                  방문하시면 확인 가능합니다.
                </li>
                <li>확인 장소: 각 건물 서버실</li>
              </ul>
            </section>

            <!-- Section 7 -->
            <section>
              <h2 class="section-heading">
                7. 정보주체의 열람 등 요구에 대한 조치
              </h2>
              <p class="mb-2">
                귀하는 개인영상정보에 관하여 열람 또는 존재확인·삭제를 원하는
                경우 언제든지 고정형 영상정보처리기기 운영자에게 요구하실 수
                있으며, 회사는 지체 없이 필요한 조치를 하겠습니다. 단, 귀하가
                촬영된 개인영상정보 및 명백히 급박한 이익이 필요한 경우에
                한정됩니다.
              </p>
              <p class="mb-2">
                다음의 경우 요청을 거부할 수 있으며, 관리책임자는 10일 이내 서면
                등으로 거부 사유를 통지합니다.
              </p>
              <ul class="list-disc list-inside space-y-1 mb-4">
                <li>보존기간 경과로 파기된 경우</li>
                <li>타인의 사생활권 침해 우려가 큰 경우</li>
                <li>기타 정당한 사유가 있는 경우</li>
              </ul>
              <div class="table-container mb-4">
                <table class="policy-table">
                  <thead class="bg-gray-100">
                    <tr>
                      <th class="px-4 py-2 border">건물</th>
                      <th class="px-4 py-2 border">촬영시간</th>
                      <th class="px-4 py-2 border">보관기간</th>
                      <th class="px-4 py-2 border">보관장소</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="px-4 py-2 border">본사</td>
                      <td class="px-4 py-2 border">24시간</td>
                      <td class="px-4 py-2 border">2주</td>
                      <td class="px-4 py-2 border">서버실</td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">연구원</td>
                      <td class="px-4 py-2 border">24시간</td>
                      <td class="px-4 py-2 border">2주</td>
                      <td class="px-4 py-2 border">서버실</td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">물류센터</td>
                      <td class="px-4 py-2 border">24시간</td>
                      <td class="px-4 py-2 border">5주</td>
                      <td class="px-4 py-2 border">서버실</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="table-container mb-8">
                <table class="policy-table">
                  <thead class="bg-gray-100">
                    <tr>
                      <th class="px-4 py-2 border">건물</th>
                      <th class="px-4 py-2 border">수탁업체</th>
                      <th class="px-4 py-2 border">담당자 및 연락처</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="px-4 py-2 border">본사</td>
                      <td class="px-4 py-2 border">에스케이쉴더스㈜</td>
                      <td class="px-4 py-2 border">
                        김형진 수석 010-3215-2558
                      </td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">연구원</td>
                      <td class="px-4 py-2 border">에스케이쉴더스㈜</td>
                      <td class="px-4 py-2 border">
                        김형진 수석 010-3215-2558
                      </td>
                    </tr>
                    <tr>
                      <td class="px-4 py-2 border">물류센터</td>
                      <td class="px-4 py-2 border">에스케이쉴더스㈜</td>
                      <td class="px-4 py-2 border">
                        김형진 수석 010-3215-2558
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>

            <!-- Section 8 -->
            <section>
              <h2 class="section-heading">8. 개인영상정보의 안전성 확보조치</h2>
              <p class="leading-relaxed">
                회사에서 처리하는 개인영상정보는 암호화 조치 등을 통하여
                안전하게 관리되고 있습니다. 또한 개인영상정보보호를 위한 관리적
                대책으로 개인정보 접근권한 차등 부여 및 위·변조 방지를 위한
                생성일시·열람 목적·열람자·열람일시 기록 관리, 안전한 물리적
                보관을 위한 잠금장치 등을 시행합니다.
              </p>
            </section>

            <!-- Section 9 -->
            <section>
              <h2 class="section-heading">9. 방침 변경에 관한 사항</h2>
              <p class="leading-relaxed">
                이 방침은 2025년 4월 1일에 제정되었으며, 법령·정책 또는 보안기술
                변경 시 내용 추가·삭제·수정이 있을 경우 시행 7일 전 회사
                홈페이지를 통해 변경사유 및 내용을 공지합니다.
              </p>
              <ul class="section-list">
                <li>공고일자: 2025년 4월 1일</li>
                <li>시행일자: 2025년 4월 1일</li>
                <li>관련법령: 「표준 개인정보 보호지침」 제36조</li>
              </ul>
            </section>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  components: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/helpers/variables";
@import "~@/assets/scss/helpers/mixins";
@import "~@/assets/scss/base/typhography";

.spolicy-intro {
  margin: 2.6rem 0;
}
.warp {
  margin: 0 auto;
  /* padding: 0 16px; */
  line-height: 1.6;
  max-width: 1400px;
}
.policy-container {
  margin: 0 auto;
  /* padding: 0 16px; */
  line-height: 1.6;
}

/* 제목 스타일 */
.policy-title {
  font-size: 2.25rem;
  font-weight: 700;
  color: #1e3a8a;
  text-align: center;
  margin-bottom: 1.5rem;
}
.policy-intro {
  font-size: 1rem;
  line-height: 1.7;
  color: #333;
  margin-bottom: 2rem;
}

/* 섹션 스타일 */
.sections > section + section {
  margin-top: 2.5rem;
}
.section-heading {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e40af;
  margin-bottom: 0.75rem;
}
.section-list {
  list-style: disc inside;
  margin-top: 0.5rem;
  line-height: 1.6;
}

/* 테이블 스타일 */
.table-container {
  overflow-x: auto;
  margin-top: 1rem;
}
.policy-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1.5rem;
}
.policy-table th,
.policy-table td {
  border: 1px solid #cbd5e1;
  padding: 0.5rem 1rem;
  text-align: left;
  vertical-align: top;
  border-bottom: none;
}
.policy-table thead {
  background-color: #e2e8f0;
}
td {
  word-break: break-all;
}
/* 반응형 */
@media (max-width: 640px) {
  .policy-title {
    font-size: 1.875rem;
  }
  .section-heading {
    font-size: 1.25rem;
  }
}

.email-protect {
  margin-bottom: 120px;
  .email-protect-ttl {
    h2 {
      margin-top: 80px;
      margin-bottom: 80px;
      text-align: center;
      font-size: 30px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: -0.9px;
    }
    .line {
      border: 1px solid #707070;
      width: 100vw;
      margin-bottom: 80px;
    }
  }
  .email-protect-txt {
    em {
      display: block;
      padding: 30px;
      background-color: #f9f9f9;
      font-size: 18px;
      line-height: 1.67;
      letter-spacing: -0.54px;
      text-align: left;
      p:last-child {
        margin: 0;
      }
    }
  }
  .txt-detail {
    margin-bottom: 120px;
    h3 {
      padding-top: 40px;
      line-height: 1.67;
      letter-spacing: -0.54px;
      font-size: 18px;
      text-align: left;
      font-weight: bold;
      margin-bottom: 30px;
    }
    p {
      line-height: 1.67;
      letter-spacing: -0.54px;
      text-align: left;
      font-size: 18px;
      margin-bottom: 30px;
    }
  }
}

@media (max-width: 640px) {
  /* 기존 헤더 숨기기 */
  .policy-table thead {
    display: none;
  }

  /* 테이블, 행, 셀을 블록으로 전환 */
  .policy-table,
  .policy-table tbody,
  .policy-table tr,
  .policy-table td {
    display: block;
    width: 100%;
  }

  /* 각 행 분리 */
  .policy-table tr {
    margin-bottom: 1rem;
    border-bottom: 1px solid #cbd5e1;
    // padding-bottom: 0.5rem;
  }

  /* 셀을 가로 정렬, 좌측에 레이블 */
  .policy-table td {
    display: flex;
    justify-content: space-between;
    padding: 0.5rem 1rem;
  }
  td {
    font-size: 0.86rem;
  }
  /* CSS로 레이블 붙이기 */
  .policy-table td:nth-child(1)::before {
    content: "건물";
  }
  .policy-table td:nth-child(2)::before {
    content: "관리책임자";
  }
  .policy-table td:nth-child(3)::before {
    content: "연락처";
  }
  .policy-table td:nth-child(4)::before {
    content: "접근권한자";
  }
  .policy-table td:nth-child(5)::before {
    content: "연락처";
  }

  /* 레이블 스타일 */
  .policy-table td::before {
    flex-basis: 40%;
    font-weight: 600;
    color: #1e40af;
  }
}
</style>
